export default {
  // AWS CUR 2.0 Fields
  optionTooltipTextbill_billing_entity:
    "The entity issuing the bill (e.g., AWS, AWS Marketplace).",
  optionTooltipTextbill_bill_type:
    "Type of bill (e.g., Anniversary, CalendarMonthly).",
  optionTooltipTextbill_payer_account_id:
    "Payer account ID (for consolidated billing).",
  optionTooltipTextbill_billing_period_start_date:
    "Start date of the billing period.",
  optionTooltipTextbill_billing_period_end_date:
    "End date of the billing period.",
  optionTooltipTextbill_invoice_id: "The ID of the invoice.",

  optionTooltipTextline_item_line_item_id:
    "Unique identifier for the line item.",
  optionTooltipTextline_item_line_item_type:
    "Type of charge (e.g., Usage, Fee, Tax, Credit).",
  optionTooltipTextline_item_usage_start_date: "Start time of the usage.",
  optionTooltipTextline_item_usage_end_date: "End time of the usage.",
  optionTooltipTextline_item_usage_account_id:
    "Account ID that incurred the cost.",
  optionTooltipTextline_item_product_code:
    "AWS service code (e.g., AmazonEC2).",
  optionTooltipTextline_item_usage_type:
    "Granular usage type (e.g., EUW2-DataTransfer-Out-Bytes).",
  optionTooltipTextline_item_operation:
    "API operation (e.g., RunInstances, GetObject).",
  optionTooltipTextline_item_resource_id:
    "Resource ID (e.g., EC2 instance ID).",
  optionTooltipTextline_item_unblended_rate: "Rate before discounts.",
  optionTooltipTextline_item_unblended_cost: "Cost before discounts.",
  optionTooltipTextline_item_blended_rate:
    "Rate after Reserved Instance/Savings Plan discounts.",
  optionTooltipTextline_item_blended_cost: "Cost after discounts.",
  optionTooltipTextline_item_currency_code: "Currency (e.g., USD).",
  optionTooltipTextline_item_availability_zone:
    "Availability Zone (e.g., us-east-1a).",
  optionTooltipTextline_item_line_item_description:
    "Human-readable description (e.g., $0.005 per 1,000 Proxy HTTPS Requests).",
  optionTooltipTextline_item_tax_type: "Tax type (e.g., Sales, VAT).",

  optionTooltipTextproduct_product_name:
    "Full product name (e.g., Amazon Elastic Compute Cloud).",
  optionTooltipTextproduct_instance_type: "Instance type (e.g., m5.large).",
  optionTooltipTextproduct_region: "AWS Region (e.g., us-west-2).",
  optionTooltipTextproduct_servicecode: "Service code (e.g., AmazonEC2).",
  optionTooltipTextproduct_sku: "Unique SKU identifier.",
  optionTooltipTextproduct_product_family:
    "Product category (e.g., Compute Instance, Storage).",
  optionTooltipTextproduct_operating_system: "OS type (e.g., Linux, Windows).",
  optionTooltipTextproduct_engine_code:
    "Database engine (e.g., Amazon RDS MySQL).",
  optionTooltipTextproduct_license_model:
    "Licensing model (e.g., Bring your own license).",
  optionTooltipTextproduct_from_location: "Source region for data transfers.",
  optionTooltipTextproduct_to_location:
    "Destination region for data transfers.",

  optionTooltipTextpricing_public_on_demand_cost:
    "Cost if billed at on-demand rates.",
  optionTooltipTextpricing_public_on_demand_rate: "On-demand rate per unit.",
  optionTooltipTextpricing_term: "Purchase term (e.g., OnDemand, Reserved).",
  optionTooltipTextpricing_unit: "Unit of measure (e.g., Hours, GB-Mo).",
  optionTooltipTextpricing_lease_contract_length:
    "Reserved Instance term length (e.g., 1yr).",
  optionTooltipTextpricing_offering_class:
    "RI offering class (e.g., standard, convertible).",
  optionTooltipTextpricing_purchase_option:
    "Purchase type (e.g., All Upfront, No Upfront).",

  optionTooltipTextreservation_reservation_arn: "ARN of the Reserved Instance.",
  optionTooltipTextreservation_effective_cost: "Cost after RI discounts.",
  optionTooltipTextreservation_start_time: "RI start time.",
  optionTooltipTextreservation_end_time: "RI end time.",
  optionTooltipTextreservation_subscription_id: "ID of the RI subscription.",
  optionTooltipTextreservation_number_of_reservations:
    "Number of RIs purchased.",
  optionTooltipTextreservation_amortized_upfront_fee:
    "Upfront fee spread over the term.",

  optionTooltipTextsavings_plan_savings_plan_arn: "ARN of the Savings Plan.",
  optionTooltipTextsavings_plan_savings_plan_rate:
    "Effective hourly rate under the SP.",
  optionTooltipTextsavings_plan_savings_plan_effective_cost:
    "Cost after SP discounts.",
  optionTooltipTextsavings_plan_region: "Region where the SP applies.",
  optionTooltipTextsavings_plan_offering_type:
    "SP type (e.g., ComputeSavingsPlans).",
  optionTooltipTextsavings_plan_payment_option:
    "SP payment option (e.g., All Upfront).",

  optionTooltipTextresource_tags_aws:
    "AWS-generated tags (e.g., aws:createdBy).",
  optionTooltipTextresource_tags_user:
    "Custom tags (e.g., user:Environment=Production).",
  optionTooltipTextresource_tags_name: "Resource name (if tagged).",

  optionTooltipTextcost_allocation_tag_key: "Key of the cost allocation tag.",
  optionTooltipTextcost_allocation_tag_value:
    "Value of the cost allocation tag.",

  optionTooltipTexttax_type: "Type of tax (e.g., Sales Tax).",
  optionTooltipTexttax_amount: "Tax amount.",

  optionTooltipTextcredit_id: "Unique identifier for the credit.",
  optionTooltipTextcredit_description:
    "Credit reason (e.g., Promotional Credit).",
  optionTooltipTextcredit_amount: "Credit value.",

  optionTooltipTextidentity_time_interval: "Time range of the usage (in UTC).",
  optionTooltipTextidentity_line_item_id: "Unique line item identifier.",

  optionTooltipTextdiscount_total_discount: "Total discount applied.",
  optionTooltipTextri_volume_discount_amount:
    "Volume discount for Reserved Instances.",
  optionTooltipTextsp_covered_cost_covered_cost:
    "Costs covered by Savings Plans.",

  // GCP Fields
  optionTooltipTextbilling_account_id:
    "The ID of the billing account associated with the charges.",
  optionTooltipTextinvoice_month: "The month of the invoice in YYYYMM format.",
  optionTooltipTextcost_type:
    "The type of cost (e.g., regular, tax, adjustment).",
  optionTooltipTextcredits_name:
    "The name of the credit applied (e.g., Free Tier, Promotion).",
  optionTooltipTextcredits_amount: "The monetary value of the credit applied.",
  optionTooltipTextcredits_id: "The unique identifier for the credit.",

  optionTooltipTextusage_start_time: "Start timestamp for the usage.",
  optionTooltipTextusage_end_time: "End timestamp for the usage.",
  optionTooltipTextusage_amount: "The quantity of usage (e.g., hours, GB).",
  optionTooltipTextusage_unit:
    "The unit of measurement for the usage (e.g., hour, gibibyte).",
  optionTooltipTextcost: "The total cost of the usage.",
  optionTooltipTextcurrency: "The currency code for the cost (e.g., USD).",
  optionTooltipTextcurrency_conversion_rate:
    "The exchange rate used for currency conversion.",

  optionTooltipTextservice_id:
    "The ID of the GCP service (e.g., 6F81-5844-456A for Compute Engine).",
  optionTooltipTextservice_description:
    "The name of the GCP service (e.g., Compute Engine, Cloud Storage).",
  optionTooltipTextsku_id: "The ID of the SKU (Stock Keeping Unit).",
  optionTooltipTextsku_description:
    "The description of the SKU (e.g., Storage PD Capacity).",
  optionTooltipTextresource_name:
    "The name of the resource (e.g., VM instance name, bucket name).",
  optionTooltipTextresource_global_name:
    "The globally unique name of the resource.",
  optionTooltipTextresource_type:
    "The type of resource (e.g., instance, bucket).",
  optionTooltipTextresource_location:
    "The location of the resource (e.g., us-central1, global).",

  optionTooltipTextproject_id: "The ID of the GCP project.",
  optionTooltipTextproject_name: "The name of the GCP project.",
  optionTooltipTextproject_number: "The number of the GCP project.",
  optionTooltipTextlabels_key: "The key of the label applied to the resource.",
  optionTooltipTextlabels_value:
    "The value of the label applied to the resource.",

  optionTooltipTextpricing_unit_price: "The unit price for the SKU.",
  optionTooltipTextpricing_usage_unit:
    "The unit of measurement for pricing (e.g., hour, gibibyte).",
  optionTooltipTextpricing_tiered_rates: "Tiered pricing rates for the SKU.",

  optionTooltipTextexport_time:
    "The timestamp when the billing data was exported.",
  optionTooltipTextadjustment_info:
    "Details about adjustments (e.g., refunds, corrections).",
  optionTooltipTextsystem_labels: "System-generated labels for the resource.",
  optionTooltipTextuser_labels: "User-defined labels for the resource.",

  // Azure Fields
  optionTooltipTextinvoiceId: "The unique identifier for the invoice.",
  optionTooltipTextbillingAccountId:
    "The ID of the billing account associated with the charges.",
  optionTooltipTextbillingAccountName: "The name of the billing account.",
  optionTooltipTextbillingPeriodStartDate: "Start date of the billing period.",
  optionTooltipTextbillingPeriodEndDate: "End date of the billing period.",
  optionTooltipTextbillingProfileId: "The ID of the billing profile.",
  optionTooltipTextbillingProfileName: "The name of the billing profile.",
  optionTooltipTextinvoiceSectionId: "The ID of the invoice section.",
  optionTooltipTextinvoiceSectionName: "The name of the invoice section.",

  optionTooltipTextusageDate: "The date of the usage.",
  optionTooltipTextproductName:
    "The name of the Azure product or service (e.g., Virtual Machines, Storage).",
  optionTooltipTextmeterName:
    "The name of the meter used for billing (e.g., Compute Hours, Data Transfer).",
  optionTooltipTextmeterCategory:
    "The category of the meter (e.g., Virtual Machines, Storage).",
  optionTooltipTextmeterSubCategory:
    "The subcategory of the meter (e.g., General Purpose, Premium SSD Managed Disks).",
  optionTooltipTextmeterRegion:
    "The region where the meter is applicable (e.g., East US, West Europe).",
  optionTooltipTextquantity: "The quantity of usage (e.g., hours, GB).",
  optionTooltipTextunitOfMeasure:
    "The unit of measurement for the usage (e.g., Hours, GB).",
  optionTooltipTextcostInBillingCurrency: "The cost in the billing currency.",
  optionTooltipTexteffectivePrice:
    "The effective price per unit after discounts.",
  optionTooltipTextcostCenter:
    "The cost center associated with the resource (if tagged).",

  optionTooltipTextresourceId: "The unique identifier of the Azure resource.",
  optionTooltipTextresourceName: "The name of the Azure resource.",
  optionTooltipTextresourceGroup:
    "The resource group to which the resource belongs.",
  optionTooltipTextresourceLocation:
    "The location of the resource (e.g., East US, West Europe).",
  optionTooltipTextconsumedService:
    "The Azure service consumed (e.g., Microsoft.Compute, Microsoft.Storage).",
  optionTooltipTextserviceFamily:
    "The family of the service (e.g., Compute, Storage).",
  optionTooltipTextserviceInfo1: "Additional service-specific information.",
  optionTooltipTextserviceInfo2: "Additional service-specific information.",

  optionTooltipTextsubscriptionId:
    "The unique identifier of the Azure subscription.",
  optionTooltipTextsubscriptionName: "The name of the Azure subscription.",
  optionTooltipTextresourceGroupName: "The name of the resource group.",

  optionTooltipTextpricingModel:
    "The pricing model used (e.g., On Demand, Reservation).",
  optionTooltipTextreservationId: "The ID of the reservation (if applicable).",
  optionTooltipTextreservationName:
    "The name of the reservation (if applicable).",
  optionTooltipTextfrequency:
    "The billing frequency (e.g., Monthly, UsageBased).",
  optionTooltipTextdiscount: "The discount applied to the cost.",
  optionTooltipTextpublisherType:
    "The type of publisher (e.g., Azure, Marketplace).",

  optionTooltipTexttags: "Tags applied to the resource for cost allocation.",
  optionTooltipTextadditionalInfo:
    "Additional information about the usage or cost.",
  optionTooltipTextofferId:
    "The ID of the Azure offer (e.g., Pay-As-You-Go, Enterprise Agreement).",
  optionTooltipTextpartNumber: "The part number of the SKU.",
  optionTooltipTextchargeType:
    "The type of charge (e.g., Usage, Purchase, Refund).",
  optionTooltipTextbenefitId:
    "The ID of the benefit applied (e.g., Azure Hybrid Benefit).",
  optionTooltipTextbenefitName: "The name of the benefit applied.",
};
